module.exports = __webpack_public_path__ + "img/deck-fi.67155c27.svg";